// The Waterfall to 98% page (Money -> Waterfall to 98%): David's audit view of a
// practice's collections. App.js renders the page; Sidebar.js carries its icon.
import React from "react";

export { default as WaterfallPage } from "./WaterfallPage";

export const waterfallIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M3 20h18" />
    <rect x="4" y="10" width="3" height="10" />
    <rect x="9" y="7" width="3" height="5" />
    <rect x="14" y="4" width="3" height="4" />
    <rect x="19" y="3" width="2" height="17" strokeDasharray="2 2" />
  </svg>
);
